import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["createAnalyticsEvent"];
export default function cleanProps(props) {
  var createAnalyticsEvent = props.createAnalyticsEvent,
    cleanedProps = _objectWithoutProperties(props, _excluded);
  return cleanedProps;
}